import { Profile } from "./Profile";
import { PropertyValue } from "./PropertyValue";
import { Downpayment } from "./Downpayment";
import { Zip } from "./Zip";
import { CreditScore } from "./CreditScore";
import Button from "@mui/material/Button";
import { EditIcon } from "../../../atoms/icons/edit";
import React from "react";
import IconButton from "@mui/material/IconButton";

export const TopStatsBarDesktop = ({
  creditScore,
  downpayment,
  price,
  setShowSettingsModal,
  zip,
}) => {
  return (
    <div className="top-stats-bar">
      <div className="top-stats-bar-inset">
        <Profile />
        <PropertyValue price={price} />
        <Downpayment downpayment={downpayment} />
        <Zip zip={zip} />
        <CreditScore
          creditScore={creditScore}
        />
      </div>
      <div className="top-stats-bar-button-wide">
        <Button
          onClick={() => setShowSettingsModal(true)}
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            color: "white",
            paddingLeft: "40px",
            paddingRight: "40px",
            display: "flex",
            alignItems: "center",
            textTransform: "none",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 10px 0px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
            "&:hover": {
              backgroundColor: "#243046",
            },
          }}
          startIcon={<EditIcon fill="white" width="16" height="16" />}
        >
          Edit Settings
        </Button>
      </div>
      <div className="top-stats-bar-button-mid">
        <IconButton
          onClick={() => setShowSettingsModal(true)}
          aria-label="Edit Profile"
        >
          <EditIcon fill="white" width="24" height="24" />
        </IconButton>
      </div>
    </div>
  );
};
